// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { boldB16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bold-b': IconBoldB;
    }
}

/**
 * The icon component for the 'boldB' icon
 */
export class IconBoldB extends IconSvg {
    public constructor() {
        super(boldB16X16);
    }
}

registerIconSvg('icon-bold-b', IconBoldB);
export const iconBoldBTag = 'nimble-icon-bold-b';
